import { Link } from 'react-router-dom'

export default function NotFound() {
  return (
    <div style={{ padding: 'var(--space-8)', textAlign: 'center' }}>
      <h1>404</h1>
      <p style={{ margin: 'var(--space-4) 0' }}>That page doesn&apos;t exist.</p>
      <Link to="/" style={{ color: 'var(--color-primary)' }}>
        Back to Home
      </Link>
    </div>
  )
}
